import { useState, useEffect } from 'react';
import { message } from 'antd';
import {
  adminService,
  CreditTransaction,
  CreditTransactionFilters,
} from '../../api/services/adminService';

export const useCreditTransactions = () => {
  const [transactions, setTransactions] = useState<CreditTransaction[]>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 20,
    pages: 0,
  });
  const [filters, setFilters] = useState<CreditTransactionFilters>({});

  const fetchTransactions = async (page = 1, limit = 20) => {
    setLoading(true);
    try {
      const response = await adminService.getCreditTransactions(filters, page, limit);
      setTransactions(response.transactions || []);
      setPagination(response.pagination || { total: 0, page: 1, limit: 20, pages: 0 });
    } catch {
      message.error('Failed to load credit transactions');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (newFilters: CreditTransactionFilters) => {
    setFilters(newFilters);
  };

  const handleTableChange = (pag: any) => {
    fetchTransactions(pag.current, pag.pageSize);
  };

  useEffect(() => {
    fetchTransactions(1, pagination.limit);
  }, [filters]);

  return {
    transactions,
    loading,
    pagination,
    filters,
    handleFilterChange,
    handleTableChange,
    refetch: () => fetchTransactions(pagination.page, pagination.limit),
  };
};
